import React from 'react';
import {Table} from '../../../components/table/Table';
import {useNavigation} from '@react-navigation/native';
import {TableHeader} from '../../../components/table/Headers';
import {AddButton} from '../../../components/button/AddButton';
import {useInvoke} from '../../../controllers/useInvoke';

export const CustomerReviewsTable = props => {
  const {
    route: {params},
  } = props;
  const {row} = params || {};
  const website = row?._id;

  const navigation = useNavigation();

  const deleteInvoke = useInvoke({
    method: 'delete',
    eventSourceId: 'customerreview',
  });

  return (
    <Table
      eventSourceId={['customerreview']}
      api={`/customerreviews`}
      fields={{
        website: {domain: 1},
        customerName: 1,
        customerTitle: 1,
        videoUrl: 1,
        logoUrl: 1,
        thumbnailUrl: 1,
        avatarUrl: 1,
      }}
      filter={{
        website,
      }}
      sort={{index: 1}}
      renderHeader={() => (
        <TableHeader
          title="Customer Reviews"
          actions={[
            <AddButton
              title="Add Customer Review"
              view="add-customer-review"
              params={{
                website,
              }}
            />,
          ]}
        />
      )}
      onRowPress={({row}) => {
        navigation.navigate('edit-customer-review', {row, website});
      }}
      columns={[
        {
          type: 'text',
          field: 'website.domain',
          header: 'Domain',
          width: 120,
        },
        {
          type: 'text',
          field: 'customerName',
          header: 'Customer Name',
        },
        {
          type: 'text',
          field: 'customerTitle',
          header: 'Customer Title',
        },
        {
          header: 'Video URL',
          field: 'videoUrl.filename',
          type: 'textArea',
        },
        {
          header: 'Logo URL',
          field: 'logoUrl.filename',
          type: 'textArea',
        },
        {
          header: 'Thumbnail URL',
          field: 'thumbnailUrl.filename',
          type: 'textArea',
        },
        {
          header: 'Avatar URL',
          field: 'avatarUrl.filename',
          type: 'textArea',
        },
      ]}
      moreActions={() => [
        {
          title: 'Edit',
          onPress: ({row}) => {
            navigation.navigate('edit-customer-review', {row, website});
          },
        },
        {
          title: 'Delete',
          confirm: {
            title: 'Delete',
            message: 'Are you sure you want to Delete?',
            confirmText: 'Delete',
          },
          onPress: ({row}) => {
            deleteInvoke({
              uri: `/customerreviews/${row?._id}`,
              props: {},
            });
          },
        },
      ]}
    />
  );
};
